var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.0983V7.73455",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51575 1.58334C6.60242 1.58334 4.24325 3.94251 4.24325 6.85584V8.51834C4.24325 9.05668 4.02159 9.86418 3.7445 10.3233L2.73909 12.0017C2.12159 13.0388 2.54909 14.1946 3.68909 14.5746C7.47325 15.8333 11.5662 15.8333 15.3503 14.5746C16.4191 14.2183 16.8783 12.9675 16.3003 12.0017L15.2949 10.3233C15.0178 9.86418 14.7962 9.04876 14.7962 8.51834V6.85584C14.7883 3.95834 12.4133 1.58334 9.51575 1.58334Z",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1362 14.8992C12.1362 16.348 10.9487 17.5355 9.49992 17.5355C8.7795 17.5355 8.1145 17.2346 7.63952 16.7596C7.16452 16.2846 6.86369 15.6196 6.86369 14.8992",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.e1aec27ee5552f7c452c985d9a49f3c1.svg";
export { ForwardRef as ReactComponent };